module.exports = __webpack_public_path__ + "fonts/akkurat-webfont.92c75385.woff";